import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

type Status = 'default' | 'wrong' | 'correct';

interface DraggableItemProps {
  item: any;
  index: number;
  blankId: string;
  status?: Status;
}
const DraggableItem = ({
  item,
  index,
  blankId,
  status,
}: DraggableItemProps) => {
  return (
    <Draggable draggableId={item.id} index={index}>
      {({ draggableProps, dragHandleProps, innerRef }) => (
        <div
          {...draggableProps}
          {...dragHandleProps}
          ref={innerRef}
          className={`cursor-pointer outline-none p-1.5 border border-1 rounded-md  text-center min-w-[60px]  ${
            blankId !== 'b-0'
              ? `bg-gray-100 
              ${
                status === 'correct'
                  ? 'bg-green-400  text-white'
                  : status === 'wrong'
                  ? 'bg-red-300  text-white'
                  : 'bg-gray-100 '
              } `
              : 'bg-primary-400 text-white w-auto '
          }`}
        >
          {item.label}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableItem;
